export const CREATE_JOIN_REQUEST_RESOURCE = 'createJoinRequest';
